import { render } from "./Label.vue?vue&type=template&id=129e2df8&scoped=true"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import "./Label.vue?vue&type=style&index=0&id=129e2df8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-129e2df8"

export default script